import type { FC } from "react";
import type { BaseToolFormData } from "../hooks/useBaseToolForm.js";
import { SharedToolFormFields } from "./sharedToolFormFields.js";

interface CallEndToolFormProps {
  name: string;
  description: string;
  settings: CallEndToolFormSettings;
  onNameChange: (name: string) => void;
  onDescriptionChange: (description: string) => void;
  onSettingsChange: (settings: Partial<CallEndToolFormSettings>) => void;
  /** The saved tool, to diff against; `undefined` for a new tool. */
  original: BaseToolFormData<CallEndToolFormSettings> | undefined;
  /** Set while a save is in flight: the editors take no edits. */
  isReadOnly: boolean;
  /** Shows the fields' changes. When set, their toggles don't render. */
  isShowingChanges?: boolean;
}

export interface CallEndToolFormSettings {}

export const CallEndToolForm: FC<CallEndToolFormProps> = ({
  name,
  description,
  onNameChange,
  onDescriptionChange,
  original,
  isReadOnly,
  isShowingChanges,
}) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <SharedToolFormFields
        name={name}
        description={description}
        onNameChange={onNameChange}
        originalName={original?.name}
        originalDescription={original?.description}
        onDescriptionChange={onDescriptionChange}
        isReadOnly={isReadOnly}
        isShowingChanges={isShowingChanges}
        namePlaceholder="End call"
        descriptionPlaceholder="Ends the current call."
      />
    </div>
  );
};
